import React from "react";
import { Header } from "../components/Header";
import { ConceptForm } from "../components/ConceptForm";
import { ContactFooter } from "../components/ContactFooter";
import { AssistantWidget } from "../components/AssistantWidget";
import { PageBanner, PageHeading } from "../components/PageBanner";
import { useLanguage } from "../i18n";
import { useSearchParams } from "react-router-dom";

// Same layout as Metodo and Servizi: title on the light band, the studio's video banner below it.
// Consulenza Esecutiva (?plan=advanced) has its own banner video; every other entry shows the Lighting Concept one
// The pricing-card name is written in capitals; page titles use normal case like Metodo and Servizi
const titleCase = (s) => s.toLocaleLowerCase().replace(/(^|\s)(\S)/g, (m, sp, c) => sp + c.toLocaleUpperCase());

export default function ConceptPage() {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const advanced = searchParams.get("plan") === "advanced";
  const bannerVideo = advanced ? "/media/consulenza-video.mp4" : "/media/concept-video.mp4";
  const advancedName = searchParams.get("plan") === "advanced" && t.pricing?.plans?.advanced?.name;
  const heading = advancedName ? titleCase(advancedName) : t.nav.cta;
  return (
    <div data-testid="concept-page" className="min-h-screen bg-cream">
      <Header />
      <main>
        <PageHeading testid="concept-heading" label={heading} />
        <PageBanner testid="concept-banner" label={heading} video={bannerVideo} mid noCaption ratio="16 / 9" />
        <ConceptForm />
      </main>
      <ContactFooter clearWidget />
      <AssistantWidget />
    </div>
  );
}
